export interface GetConstantCategoryListPagingAndFilterResponse {
    isSuccess: boolean
    message: any
    data: GetConstantCategoryListPagingAndFilterResponseData
}

export interface GetConstantCategoryListPagingAndFilterResponseData {
    items: GetConstantCategoryListPagingAndFilterResponseItem[]
    totalRecordCount: number
}

export interface GetConstantCategoryListPagingAndFilterResponseItem {
    constantCategoryId: string
    code: string
    name: string
    companyId?: string
    createdDate: string
    createdUser: string
    updatedDate: string
    updatedUser: string
    isSelected: boolean
}

export const initialGetConstantCategoryListPagingAndFilterResponseData: GetConstantCategoryListPagingAndFilterResponseData = {
    items: [],
    totalRecordCount: 0
}